/**
 * Account layout
 * This is the layout for the non-authenticated users
 */
import React, { Component } from "react"
import { ThemeProvider } from "styled-components"
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles"
import theme from "styles/theme-main"
import { Helmet } from "react-helmet-async"
import { Body, Separator, Wrapper, LoginHeader } from "./styles"
import LayoutContainer from "components/LayoutContainer"
import Logo from "components/Logo"
import Maintenance from "components/Maintenance"
import Footer from "components/Footer"
import { convertMUI, getHomeRoute } from "utils/utils"
import {
  getSubdomainFromUrl,
  isProfileMode,
  isInternalMode,
} from "utils/productUtils"
import { getClientLayoutConfiguration } from "utils/clientUtils"

class AccountLayout extends Component {
  componentDidMount() {
    const subdomain = getSubdomainFromUrl()
    if (subdomain && !this.props.organization) {
      this.props.getOrganization(subdomain)
    }
  }

  render() {
    const props = this.props

    if (props.organization) {
      const orgtheme = JSON.parse(props.organization.themeConfiguration || "{}")
      if (orgtheme.headerBGcolour) {
        theme.colors.headerBGcolour = orgtheme.headerBGcolour
      } else {
        theme.colors.headerBGcolour = "#ffffff"
      }
    }

    // In Vantage mode we always want to have a white background.
    // Under certain circumstances we were getting strange BG colours,
    // So this line fixes that.
    if (isProfileMode()) theme.colors.headerBGcolour = "#ffffff"

    theme.colors.primary = theme.colors.vantageHighlight
    theme.colors.secondary = theme.colors.vantageHighlight
    theme.buttons.primary.background = theme.colors.vantageHighlight

    const muitheme = createTheme(convertMUI(theme))

    const homePath = getHomeRoute(this.props.user, this.props.organization)
    let logoURL = this.props.organization && this.props.organization.logoURL
    if (isInternalMode()) {
      logoURL = `https://d20xob8nnh02en.cloudfront.net/rare-logo.png`
    }

    const { title, description } = getClientLayoutConfiguration(
      props.organization,
      props.role
    )

    return (
      <ThemeProvider theme={theme}>
        <MuiThemeProvider theme={muitheme}>
          <Wrapper>
            <Helmet>
              <title>{title}</title>
              <meta name="title" content={title} />
              <meta name="description" content={description} />
            </Helmet>
            <Maintenance />
            <LoginHeader theme={theme}>
              <Logo variant={"account"} path={homePath} logoURL={logoURL} />
            </LoginHeader>
            <LayoutContainer narrow>
              <Separator />
            </LayoutContainer>
            <Body>
              <LayoutContainer narrow>{this.props.children}</LayoutContainer>
            </Body>
            <Footer />
          </Wrapper>
        </MuiThemeProvider>
      </ThemeProvider>
    )
  }
}

export default AccountLayout
